import React, { useState } from "react";
import Sidebar from "../../components/SideBar";
import Header from "../../components/Header";
import Coupones from "./componenets/coupones";

const Inventory = () => {
  const [activePage, setActivePage] = useState("Coupones");
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);

  const handleNavigate = (page) => {
    setActivePage(page);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <div className="flex min-h-screen bg-[#F8F4F4]">
      <Sidebar active={activePage} onNavigate={handleNavigate} />
      <div className="flex-1 py-6 px-8 max-h-screen min-h-screen overflow-scroll">
        <Header onSearch={handleSearch} hideSearch={showAddForm} />
        <Coupones 
          searchQuery={searchQuery} 
          showAddForm={showAddForm}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </div>
  );
};

export default Inventory;
